import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const FillMessageIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M13.1667 0.898682H1.83341C1.05425 0.898682 0.423831 1.53618 0.423831 2.31535L0.416748 10.8153C0.416748 11.5945 1.05425 12.232 1.83341 12.232H13.1667C13.9459 12.232 14.5834 11.5945 14.5834 10.8153V2.31535C14.5834 1.53618 13.9459 0.898682 13.1667 0.898682ZM12.8834 3.9091L7.8755 7.03993C7.64883 7.1816 7.35133 7.1816 7.12467 7.03993L2.11675 3.9091C2.04572 3.86923 1.98352 3.81536 1.93392 3.75075C1.88431 3.68615 1.84833 3.61215 1.82816 3.53324C1.80798 3.45432 1.80402 3.37214 1.81653 3.29165C1.82903 3.21116 1.85774 3.13405 1.90091 3.06498C1.94408 2.99591 2.00081 2.93631 2.06768 2.8898C2.13455 2.84329 2.21016 2.81084 2.28993 2.79439C2.36971 2.77795 2.45199 2.77787 2.5318 2.79414C2.61161 2.81042 2.68728 2.84273 2.75425 2.8891L7.50008 5.85701L12.2459 2.8891C12.3129 2.84273 12.3886 2.81042 12.4684 2.79414C12.5482 2.77787 12.6305 2.77795 12.7102 2.79439C12.79 2.81084 12.8656 2.84329 12.9325 2.8898C12.9994 2.93631 13.0561 2.99591 13.0993 3.06498C13.1424 3.13405 13.1711 3.21116 13.1836 3.29165C13.1961 3.37214 13.1922 3.45432 13.172 3.53324C13.1518 3.61215 13.1158 3.68615 13.0662 3.75075C13.0166 3.81536 12.9544 3.86923 12.8834 3.9091Z"
    />
  </svg>
);

FillMessageIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

FillMessageIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(15, 11),
};

export default FillMessageIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/fill-message.js